import env from '@beam-australia/react-env';
import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LoadingButton from '@mui/lab/LoadingButton';
import ConnectionStatus from '@/constants/ConnectionStatus';
import IntegrationID from '@/constants/integrations/IntegrationID';
import translate from '@/lib/intl/translate';
import {
  IntegrationContentContainer,
  IntegrationContentDescription,
  IntegrationContentHeader,
} from '@/modules/Integrations';
import CredentialsConfirmRemoveModal from '@/pages/IntegrationPage/CredentialsConfirmRemoveModal';
import CredentialsLoader from '@/pages/IntegrationPage/CredentialsLoader';
import useIWaveConnectIntegration from '../hooks/useIWaveConnectIntegration';

const REDIRECT_URI = `${env('BASE_URL')}auth/iwave/callback`;
const IWAVE_URL = `https://auth.app.iwave.com/oauth2/authorize?client_id=${env(
  'IWAVE_CLIENT_ID',
)}&response_type=code&scope=openid&redirect_uri=${REDIRECT_URI}`;

export default function ConnectToIWave() {
  const { connectionStatus, disconnectIWave, isLoading, isDisconnecting } =
    useIWaveConnectIntegration();
  const [isConnecting, setIsConnecting] = React.useState(false);
  const [confirmRemoveModalIsOpen, setConfirmRemoveModalIsOpen] =
    React.useState(false);

  const handleCloseConfirmRemoveModal = () => {
    setConfirmRemoveModalIsOpen(false);
  };
  const handleOpenConfirmRemoveModal = () => {
    setConfirmRemoveModalIsOpen(true);
  };

  const hasCredentials = connectionStatus === ConnectionStatus.CONNECTED;

  if (isLoading) {
    return <CredentialsLoader integrationId={IntegrationID.IWAVE} />;
  }

  return (
    <>
      <IntegrationContentContainer>
        <IntegrationContentHeader>
          {translate('IWAVE_INTEGRATION_CONNECTION_HEADER')}
        </IntegrationContentHeader>

        <IntegrationContentDescription>
          {translate(
            hasCredentials
              ? 'IWAVE_INTEGRATION_CONNECTION_CONNECTED_DESCRIPTION'
              : 'IWAVE_INTEGRATION_CONNECTION_DESCRIPTION',
          )}
        </IntegrationContentDescription>

        {!hasCredentials ? (
          <LoadingButton
            component="a"
            href={IWAVE_URL}
            id="iwave-connect"
            loading={isConnecting}
            onClick={() => {
              setIsConnecting(true);
            }}
            startIcon={<OpenInNewIcon />}
            target="_blank"
            variant="contained"
          >
            {translate('INTEGRATIONS_CTA_CONNECT')}
          </LoadingButton>
        ) : (
          <LoadingButton
            color="destructive"
            id="iwave-disconnect"
            loading={isDisconnecting}
            onClick={handleOpenConfirmRemoveModal}
            variant="contained"
          >
            {translate('INTEGRATIONS_REMOVE_CONNECTION')}
          </LoadingButton>
        )}
      </IntegrationContentContainer>

      <CredentialsConfirmRemoveModal
        open={confirmRemoveModalIsOpen}
        handleClose={handleCloseConfirmRemoveModal}
        handleRemove={disconnectIWave}
        setOpen={setConfirmRemoveModalIsOpen}
      />
    </>
  );
}
